import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

type FetchCompany = {
  companyId: string;
};

export const useCheckCardPaymentIntent = ({ companyId }: FetchCompany) => {
  const queryClient = useQueryClient();

  const { mutate } = useAppMutation([QueryKey.CHECK_CARD_PAYMENT_INTENT, companyId], {
    mutationFn: ({ paymentIntentId }: { paymentIntentId: string }) =>
      ApiService.post<{ isValid: string }>(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'check-card-payment-intent'],
        },
        {
          body: { paymentIntentId },
        },
      ),
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.CHECK_CARD_PAYMENT_INTENT] });
  }, [queryClient]);

  return {
    checkCardPaymentIntent: mutate,
    invalidateQuery,
  };
};
